import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp';
import { IconButton, IconButtonProps } from 'shared/mui/IconButtons';

export type ExpandIconButtonProps = Omit<IconButtonProps, 'icon'> & { isExpanded: boolean };

export function ExpandIconButton({ isExpanded, ...restProps }: ExpandIconButtonProps): JSX.Element {
  return (
    <IconButton {...restProps}>
      {isExpanded ? <KeyboardArrowUp color="secondary" /> : <KeyboardArrowDown color="secondary" />}
    </IconButton>
  );
}
